<template>
  <div class="login">
    <div id="top">
      <div class="inner" style="display: none">
        <div class="f_left">石家庄市国经人力资源管理有限公司</div>
        <ul class="f_right">
          <li class="qqtalk"></li>
          <li>
            <router-link to="register">注册</router-link>
          </li>
          <li><router-link to="login">登录</router-link></li>
          <li class="line"><a href="">常见问题</a></li>
          <li class="line"><a href="" target="_blank">承诺书</a></li>
          <li id="home_top_wzq">
            <a>网站群</a>
            <div class="sub-navgation">
              <ul>
                <li class="header_less_link">
                  <a target="_blank" href="http://124.70.105.214:9031/">总站</a>
                </li>
                <li class="header_less_link">
                  <a target="_blank" href="http://124.70.105.214:9031/"
                    >大中专毕业生就业服务网</a
                  >
                </li>
                <li class="header_less_link">
                  <a target="_blank" href="http://124.70.105.214:9031/"
                    >石家庄国经人力资源网</a
                  >
                </li>
                <li class="header_less_link">
                  <a target="_blank" href="http://124.70.105.214:9031/"
                    >人力资源外包</a
                  >
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div id="login_header">
      <div class="inner">
        <h1>用户登陆</h1>
        <ul>
          <li>
            <a style="font-weight: bold; color: #0162b1" href="/">网站首页</a>
          </li>
          <li>服务热线:0311-86960522</li>
        </ul>
      </div>
    </div>
    <div id="login_content" style="display: flex">
      <div class="left"><img src="@/assets/images/gerenad.jpg" /></div>
      <div class="box"  style="display: none">
        <div class="content">
          <h2>登录</h2>
          <div>
            <input
              type="text"
              v-model="loginForm.username"
              placeholder="请输入用户名"
            />
          </div>
          <div>
            <input
              type="password"
              v-model="loginForm.password"
              placeholder="请输入密码"
            />
          </div>
          <div style="display: flex">
            <input
              type="text"
              v-model="loginForm.code"
              placeholder="请输入验证码"
            />
            <img
              @click="getCode"
              id="verifyImg"
              :src="codeUrl"
              border="0"
              alt="点击刷新验证码"
              style="
                margin-top: 12px;
                height: 30px;
                float: right;
                margin-right: 10px;
              "
              align="absmiddle"
            />
          </div>

          <div>
            <input type="submit" value="登录" @click="login()" />
          </div>
        </div>
        <a href="#" @click="forgetPassword()" class="btns">忘记密码</a>
        <a href="#" @click="toRegister()" class="btns register">注册</a>
      </div>
      <div class="right">
        <div class="top"></div>
        <div class="mid">
          <div class="title">
            <h2 style="margin-top: 0px; padding-top: 16px">用户登录</h2>
          </div>
          <div class="line"></div>
          <div class="forms">
            <div class="form" id="login">
              <div class="form_item">
                <label for="account">身份证号码：</label>
                <input
                  v-model="loginForm.username"
                  id="account"
                  class="text"
                  type="text"
                  name="account"
                  datatype="*"
                  nullmsg="*请输入用户名！"
                  sucmsg="用户名已输入"
                />
              </div>
              <div class="form_item">
                <label for="password">密码：</label
                ><input
                  v-model="loginForm.password"
                  id="password"
                  class="text"
                  type="password"
                  name="password"
                  datatype="*"
                  nullmsg="*请输入密码！"
                  sucmsg="密码已输入"
                />
              </div>
              <div>
                <label for="verify">验证码：</label
                ><input
                  v-model="loginForm.code"
                  id="verify"
                  class="text"
                  type="text"
                  name="verify"
                  style="width: 65px"
                /><img
                  @click="getCode"
                  id="verifyImg"
                  :src="codeUrl"
                  border="0"
                  alt="点击刷新验证码"
                  style="
                    margin-bottom: 4px;
                    margin-top: -8px;
                    cursor: pointer;
                    height: 30px;
                    float: right;
                    margin-left: 27px;
                  "
                  align="absmiddle"
                />
              </div>
              <div
                id="message"
                class="login_msg form_item"
                style="text-align: left"
              >
                *请输入您的身份证号码进行登录。
              </div>
              <input
                id="vt"
                class="text"
                type="hidden"
                name="vt"
                value="1655868080"
              />
              <div class="login_btn_form">
                <a
                  ><input
                    type=""
                    id="submit"
                    value=""
                    class="loginnow"
                    style="cursor: pointer"
                    @click="login()"
                /></a>
                <span>
                  <router-link to="forgetPassword">忘记密码？</router-link>
                </span>
              </div>
            </div>
          </div>
          <div class="msg1">
            <span>还没有账号？</span>
            <router-link
              :to="{
                name: 'register',
                path: '/register',
                query: {
                  redirect: this.$route.query.redirect,
                },
              }"
              >立即注册！</router-link
            >
          </div>
        </div>
        <div class="bottom"></div>
      </div>
    </div>
  </div>
</template>

<script>
import base64 from "base-64";
import router from "@/router";
export default {
  data() {
    return {
      phone: "",
      code: "",
      name: "",
      password: "",
      getCodeShow: true,
      seconds: 60,
      timer: null,
      loginType: "zhanghao",
      weixin: "微信登录",
      savePwd: false,
      codeUrl: "",
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
        code: "",
        uuid: "",
      },
    };
  },
  created() {
    let _this = this;
    _this.getCode();
    console.log("this.$route.params", _this.$route.query.redirect);
  },
  methods: {
    forgetPassword() {
      this.$router.push({
        path: "/forgetPassword",
      });
    },
    toRegister() {
      this.$router.push({
        path: "/register",
        query: {
          redirect: this.$route.query.redirect,
        },
      });
    },
    getCode() {
      let _this = this;
      _this.$api.code.code().then((res) => {
        _this.captchaOnOff =
          res.captchaOnOff === undefined ? true : res.captchaOnOff;
        if (_this.captchaOnOff) {
          _this.codeUrl = "data:image/gif;base64," + res.img;
          _this.loginForm.uuid = res.uuid;
        }
      });
    },
    login() {
      let _this = this;
      if (!_this.loginForm.username) {
        _this.$layerMsg.error("请填写账号");
        return false;
      }
      if (!_this.loginForm.password) {
        _this.$layerMsg.error("请填写密码");
        return false;
      }

      if (_this.loginForm.code == "") {
        _this.$layerMsg.error("请填写验证码");
        return false;
      }
      let param = {
        username: this.loginForm.username,
        password: this.loginForm.password,
        code: this.loginForm.code,
        uuid: this.loginForm.uuid,
      };

      _this.$api.user
        .userLogin(param)
        .then((res) => {
          if (res.code == _this.$commons.RespCode.success) {
            _this.$cookies.set(
              _this.$commons.User.Authentication,
              res.data.access_token
            ); //登录凭证
            _this.$cookies.set(
              _this.$commons.User.userName,
              this.loginForm.username
            ); //登录用户名
            _this.$cookies.set(_this.$commons.User.identity, res.data.identity); //登录用户类型 01-个人 02-企业用户
            _this.$router.push({
              path:
                _this.$route.query.redirect &&
                _this.$route.query.redirect.indexOf("login") == -1 &&
                _this.$route.query.redirect.indexOf("register") == -1
                  ? _this.$route.query.redirect
                  : "/",
            });
          } else {
            _this.$layerMsg.error(res.msg);
            _this.getCode();
          }
        })
        .catch(() => {});
    },
    loginByName() {
      let _this = this;
      if (_this.name.length <= 0) {
        _this.$layerMsg.error("请填写账号");
        return false;
      }
      // if (!_this.$util.checkPhone(_this.name)) {
      //   _this.$layerMsg.error("请填写正确的手机号");
      //   return false;
      // }
      if (_this.password == "") {
        _this.$layerMsg.error("请填写密码");
        return false;
      }
      _this.$api.user
        .userLogin(_this.name, _this.password)
        .then((res) => {
          if (res.errorCode == _this.$commons.RespCode.success) {
            _this.$cookies.set(
              _this.$commons.User.Authentication,
              res.data.Authentication
            ); //登录凭证
            _this.$cookies.set(_this.$commons.User.userName, res.data.userName); //登录用户名
            _this.$cookies.set(_this.$commons.User.identity, res.data.identity); //登录用户名
            // _this.$cookies.set(_this.$commons.User.realName, res.data.realName); //真实姓名
            // _this.$cookies.set(_this.$commons.User.userId, res.data.userId); //用户Id
            // _this.$cookies.set(_this.$commons.User.headUrl, res.data.headUrl); //用户Id
            if (_this.savePwd) {
              _this.$cookies.set(
                _this.$commons.User.pass,
                base64.encode(_this.password)
              ); //密码
            } else {
              _this.$cookies.remove(_this.$commons.User.pass);
            }
            _this.$router.push({
              path:
                _this.$route.query.redirect &&
                _this.$route.query.redirect.indexOf("login") == -1 &&
                _this.$route.query.redirect.indexOf("register") == -1 &&
                _this.$route.query.redirect.indexOf("forgetPassword") == -1
                  ? _this.$route.query.redirect
                  : "/",
            });
          } else {
            _this.$layerMsg.error(res.msg);
          }
        })
        .catch(() => {});
    },
    goPath() {
      let _this = this;
      _this.$router.push({
        path:
          _this.$route.query.redirect &&
          _this.$route.query.redirect.indexOf("login") == -1 &&
          _this.$route.query.redirect.indexOf("register") == -1
            ? _this.$route.query.redirect
            : "/",
      });
    },
    weixinAuth() {
      let _this = this;
      _this.weixin = "微信授权";
    },
  },
};
</script>

<style>
#qrcode iframe {
  width: 100% !important;
  height: 303px !important;
}
#qrcode iframe .impowerBox .normalPanel .title {
  display: none;
}
#qrcode iframe .impowerBox .qrcode {
  width: 210px;
}
.link {
  position: absolute;
  top: 145px;
  color: #4e6ef2;
}
.toReg {
  right: 0;
}
.resetPwd {
  right: 80px;
}
.login-type {
  width: 335px;
  margin: 0 auto;
}
.save-pwd {
  position: absolute;
  top: 145px;
}
.save-pwd input,
.save-pwd span {
  vertical-align: middle;
  cursor: pointer;
}
.login-type::after {
  content: "";
  width: 0;
  height: 0;
  margin: 0;
  clear: both;
  display: block;
}
.login-type .type-item {
  float: left;
  width: 50%;
  font-size: 22px;
  margin: 40px 0;
  text-align: center;
  cursor: pointer;
}
.login-type .type-item.sel {
  color: #be1a21;
}
.box {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin: 40px auto;
  width: 470px;
}

.box .content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 380px;
  height: 380px;
  padding: 60px 20px;
  box-shadow: inset 20px 20px 20px rgba(0, 0, 0, 0.05),
    25px 35px 20px rgba(0, 0, 0, 0.05), 25px 30px 30px rgba(0, 0, 0, 0.05),
    inset -20px -20px 25px rgba(255, 255, 255, 0.9);
}

.box .content {
  border-radius: 52% 48% 33% 67% / 38% 45% 55% 62%;
  transition: 0.5s;
}

.box .content:hover {
  border-radius: 50%;
}

.box .content::before {
  content: "";
  position: absolute;
  top: 50px;
  left: 85px;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: #fff;
  opacity: 0.9;
}

.box .content::after {
  content: "";
  position: absolute;
  top: 90px;
  left: 110px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #fff;
  opacity: 0.9;
}

.box .content div {
  position: relative;
  width: 225px;
  border-radius: 25px;
  box-shadow: inset 2px 5px 10px rgba(0, 0, 0, 0.1),
    inset -2px -5px 10px rgba(255, 255, 255, 1),
    15px 15px 10px rgba(0, 0, 0, 0.05), 15px 10px 15px rgba(0, 0, 0, 0.025);
}

.box .content div::before {
  content: "";
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: 65%;
  height: 5px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 5px;
}

.box .content input {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
  padding: 10px 15px;
}

.box .content input[type="submit"] {
  color: #fff;
  cursor: pointer;
}

.box .content div:last-child {
  width: 120px;
  background: #0a5ac9;
  box-shadow: inset 2px 5px 10px rgba(0, 0, 0, 0.1),
    15px 15px 10px rgba(0, 0, 0, 0.05), 15px 10px 15px rgba(0, 0, 0, 0.025);
  transition: 0.5s;
}

.box .content div:last-child:hover {
  width: 150px;
}

.btns {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 120px;
  height: 120px;
  /* background: #c61dff; */
  background: #fc9522;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  color: #fff;
  font-size: 14px;
  box-shadow: inset 10px 10px 10px rgba(190, 1, 254, 0.05),
    15px 25px 10px rgba(190, 1, 254, 0.1), 15px 20px 20px rgba(190, 1, 254, 0.1),
    inset -10px -10px 15px rgba(255, 255, 255, 0.5);
  border-radius: 44% 56% 65% 35% / 57% 58% 42% 43%;
}

.register {
  bottom: 150px;
  right: 0px;
  width: 80px;
  height: 80px;
  border-radius: 49% 51% 52% 48% / 63% 59% 41% 37%;
  background: #01b4ff;
  box-shadow: inset 10px 10px 10px rgba(1, 180, 255, 0.05),
    15px 25px 10px rgba(1, 180, 255, 0.1), 15px 20px 20px rgba(1, 180, 255, 0.1),
    inset -10px -10px 15px rgba(255, 255, 255, 0.5);
}

.btns::before {
  content: "";
  position: absolute;
  top: 15px;
  left: 30px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  opacity: 0.45;
}

.register::before {
  left: 20px;
  width: 15px;
  height: 15px;
}

.btns {
  transition: 0.25s;
}

.btns:hover {
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/view/login/login.vue